<template>
  <div>
    <div v-show="showEdit">
      <Edit v-if="showEdit" :params="params" />
    </div>
    <div v-show="!showEdit">
      <p v-if="availableChannelsAlert">
        <b-alert show variant="warning">
          Você não possui nenhuma integração.
          <a href="https://painel.plugg.to/settings">{{ $t("Clique aqui") }}</a>
          para configurar.
        </b-alert>
      </p>
      <br />
      <b-row>
        <b-col>
          <ScreensMenu />
        </b-col>
      </b-row>
      <br />
      <br />
      <TabsComponent
        v-if="isInitialReady"
        :options_por_conta="options_por_conta"
        :checkFaturador="checkFaturador"
        :usr_orders="usr_orders"
        :availableChannels="availableChannels"
        :apps="apps"
      />
      <back-to-top bottom="50px" right="3%">
        <button v-b-tooltip.hover title="Voltar para o topo" type="button" class="btn btn-info btn-to-top">
          <i class="fa fa-chevron-up"></i>
        </button>
      </back-to-top>
    </div>
  </div>
</template>

<script>
import NavBarAcitions from "./Aggregates/NavBarActions.vue";
import ScreensMenu from "./Aggregates/ScreensMenu.vue";
import TabsComponent from "./Aggregates/Tabs.vue";
import barramento from "../../barramento";
import Edit from "./Aggregates/Edit.vue";
import BackToTop from "vue-backtotop";
import axios from "axios";

export default {
  name: "Order",
  components: {
    NavBarAcitions,
    ScreensMenu,
    TabsComponent,
    BackToTop,
    Edit,
  },
  data() {
    return {
      usr_orders: null,
      isInitialReady: false,
      checkFaturador: false,
      availableChannels: [{ value: null, text: "Selecione um canal..." }],
      availableChannelsAlert: false,
      options_por_conta: [{ value: null, text: "Selecione a conta..." }],
      showEdit: false,
      params: null,
      apps: [],
      scrollYSave: null,
    };
  },
  methods: {
    async getInitialData() {
      try {
        const response = await axios.get("/api/user");
        this.usr_orders = response.data;
      } catch (error) {
      } finally {
        this.isInitialReady = true;
      }
    },
    loadDeferredData() {
      this.loadAccounts();
      this.loadApps();
    },
    loadAccounts() {
      axios
        .get("/api/user/account")
        .then((response) => {
          response.data.forEach((channel) => {
            this.options_por_conta.push({
              value: channel.channel_account.name,
              text: channel.channel_account.name,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    loadApps() {
      axios
        .get("/api/orders/apps")
        .then((response) => {
          if (response.data.length) {
            var availableChannels_aux = [];

            this.apps = response.data;

            response.data.forEach((channel) => {
              if (
                channel.category == 3 ||
                channel.category == 4 ||
                channel.category == null
              ) {
                availableChannels_aux.push({
                  value: channel.client_id,
                  text: channel.name,
                });
              }
              if (
                channel.category == 1 &&
                channel.client_id == "ff7d9cb152549fb4e05bb956909742a4"
              ) {
                this.checkFaturador = true;
              }
            });

            availableChannels_aux = availableChannels_aux.sort((a, b) => {
              return a.text > b.text ? 1 : b.text > a.text ? -1 : 0;
            });

            for (var i in availableChannels_aux) {
              this.availableChannels.push(availableChannels_aux[i]);
            }

            this.availableChannelsAlert = this.availableChannels.length == 0;
          }
        })
        .catch((error) => console.warn(error));
    },
    scheduleDeferredLoad() {
      if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(() => this.loadDeferredData(), { timeout: 800 });
        return;
      }

      setTimeout(() => this.loadDeferredData(), 0);
    }
  },
  mounted() {
    this.getInitialData().then(() => {
      this.scheduleDeferredLoad();
    });
  },
  beforeDestroy() {
    barramento.$off("order_edit");
    barramento.$off("order_edit_close");
  },
  created() {
    barramento.$on("order_edit", (params) => {
      this.params = params;
      this.showEdit = true;
      this.scrollYSave = window.pageYOffset;
      window.scrollTo(0, 0);
    });
    barramento.$on("order_edit_close", () => {
      this.params = null;
      this.showEdit = false;

      window.scrollTo(0, this.scrollYSave);

      setTimeout(() => {
        window.scrollTo(0, this.scrollYSave + 120);
      }, 1000);
    });
  },
};
</script>
<style>
.steps-form-2 {
  display: table;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 50px;
  position: relative;
}

.steps-form-2 .steps-row-2 {
  display: table-row;
}

.steps-step-2.off::after {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 434%;
  height: 2px;
  background-color: #868e96;
  margin-left: 35px;
}

.steps-form-2 .steps-row-2:before {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  height: 2px;
  background-color: #14cc4b;
  width: 1000%;
}

span.btn.btn-amber.btn-circle-2.waves-effect.inactive {
  border: 2px solid #868e96;
  background-color: white !important;
  color: #868e96;
}

.steps-form-2 .steps-row-2 .steps-step-2 {
  display: table-cell;
  text-align: center;
  position: relative;
}

.steps-form-2 .steps-row-2 .steps-step-2 p {
  margin-top: 0.5rem;
}

.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 {
  width: 70px;
  height: 70px;
  border: 2px solid #14cc4b;
  background-color: white !important;
  color: #14cc4b;
  border-radius: 50%;
  padding: 22px 18px 15px 18px;
  margin-top: -22px;
}

.error {
  width: 70px;
  height: 70px;
  border: 2px solid rgb(201, 9, 9) !important;
  background-color: rgb(201, 9, 9) !important;
  color: rgb(201, 9, 9) !important;
  border-radius: 50%;
  padding: 22px 18px 15px 18px;
  margin-top: -22px;
}

.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 .fa {
  font-size: 1.7rem;
}

.steps-form-2 .tag {
  display: block;
  margin-top: 15px;
}

.steps-form-2 .tag:hover {
  text-decoration: none;
}

#steps_status {
  cursor: default !important;
}

.swal2-icon.swal2-warning {
  font-size: inherit !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Order.vue